class TypewritingText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const text = this.getAttribute("text") || "Typewriting text";
    const tag = this.getAttribute("tag") || "h2";

    // Build structure directly in light DOM
    this.innerHTML = `
      <div class="js-typewrite">
        <div class="text__wrapper" data-text="${text}">
          <${tag} class="m-0"></${tag}>
        </div>
      </div>
    `;

    const typewriteElement = this.querySelector('.js-typewrite');
    const textWrapper = typewriteElement.querySelector('.text__wrapper');
    const targetText = textWrapper.getAttribute('data-text');
    const textElement = textWrapper.querySelector(tag);

    // Prepare container
    textElement.textContent = '';
    const textContainer = document.createElement('span');
    textContainer.classList.add('text-container');
    textElement.appendChild(textContainer);

    // Create character spans
    targetText.split('').forEach(char => {
      const span = document.createElement('span');
      span.textContent = char === ' ' ? '\u00A0' : char;
      span.style.opacity = '0'; // Start hidden
      span.style.display = 'inline-block';
      textContainer.appendChild(span);
    });

    // Use Intersection Observer instead of ScrollTrigger
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateText(textContainer);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe(typewriteElement);
  }

  animateText(textContainer) {
    const chars = textContainer.children;
    const tl = gsap.timeline();
    
    Array.from(chars).forEach((char, i) => {
      tl.to(char, { opacity: 1, duration: 0.05 }, i * 0.05);
    });
  }
}

customElements.define("typewriting-text", TypewritingText);